import React, { memo } from 'react'
import moment from 'moment-jalaali'
import { change_success, change_warning } from '../../functions/stateList'
import EmptyTableContent from '../error/EmptyTableContent'
import TableSkeleton from '../skeleton/tableSkeleton'
import { priceFormat } from '../../assets/scripts/GeneralFunctions'

function ServiceTable({ services, activeTitle, current_km }) {
  const service = {
    oil: services?.filter((service) => service?.['service_category'] === 'خدمات تعویض روغن'),
    mechanics: services?.filter((service) => service?.['service_category'] === 'خدمات مکانیکی'),
    rubber: services?.filter((service) => service?.['service_category'] === 'خدمات لاستیک'),
    cleanliness: services?.filter((service) => service?.['service_category'] === 'خدمات نظافتی'),
  }

  return (
    <div className="relative rounded-2xl border border-light-gray dark:border-gray-700 mb-16 overflow-auto scroll-smooth">
      {service[activeTitle]?.length > 0 ? (
        <table className="w-full text-sm text-right relative whitespace-nowrap">
          <thead className="text-md bg-light-blue dark:bg-slate-800 sticky top-0 w-full">
            <tr className={'border-b border-b-light-gray dark:border-b-gray-700 text-right'}>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                نوع سرویس
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                وضعیت
              </th>
              {activeTitle !== 'rubber' && activeTitle !== 'cleanliness' && (
                <th scope="col" className="px-6 py-4 dark:text-amber-100">
                  برند
                </th>
              )}
              {activeTitle !== 'cleanliness' && (
                <th scope="col" className="px-6 py-4 dark:text-amber-100">
                  حداکثر کارکرد (km)
                </th>
              )}
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                تاریخ
              </th>
            </tr>
          </thead>

          <tbody className={'text-md bg-light-blue dark:bg-slate-800'}>
            {service[activeTitle]?.map((service, index) => {
              return !service ? (
                <TableSkeleton key={index} index={index} count={4} />
              ) : (
                <tr
                  key={service.id}
                  className="border-b border-b-light-gray dark:border-b-gray-700 text-right"
                >
                  <td className="px-6 py-4 dark:text-amber-50">{service?.['service_type']}</td>
                  <td className={`px-6 py-4`}>
                    {service?.['service_description'] === 'changed' ? (
                      <div className={change_success}>
                        <i className={'icon-tick-circle pl-2 text-xl text-success'} />
                        تعویض شد
                      </div>
                    ) : (
                      <div className={change_warning}>
                        <i className={'icon-danger pl-2 text-xl text-warning'} />
                        تعویض در مراجعه بعد
                      </div>
                    )}
                  </td>
                  {activeTitle !== 'rubber' && activeTitle !== 'cleanliness' && (
                    <td className="px-6 py-4 dark:text-amber-50">
                      {service?.product ? service?.product?.name : '- - -'}
                    </td>
                  )}
                  {activeTitle !== 'cleanliness' && (
                    <td className="px-6 py-4 dark:text-amber-50">
                      {service?.useful_km && current_km
                        ? priceFormat(parseInt(current_km) + parseInt(service?.useful_km))
                        : '- - -'}
                    </td>
                  )}
                  <td className="px-6 py-4 dark:text-amber-50">
                    {service?.['created_at']
                      ? `${moment(service?.['created_at']).format('jYYYY-jMM-jDD')}`
                      : '- - -'}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      ) : (
        <EmptyTableContent text={'سرویسی ارائه نشده است.'} />
      )}
    </div>
  )
}

export default memo(ServiceTable)
